<template>
  <v-data-table
    :key="customersQueryKey"
    :headers="leadsHeaders"
    :items="leads"
    :loading="loading"
    item-key="_id"
    class="elevation-1"
    loading-text="Данные загружаются... Пожалуйста, подождите."
  >
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | localDatetime }}
    </template>
    <template v-slot:[`item.customer`]="{ item }">
      <div class="id-block">
        <customer-card :id="item.customer.id"></customer-card>
        <template v-if="item.customer.utm && item.customer.utm.source">
          <!-- Иконка utm_source -->
          <img v-if="item.customer.utm.source == 'instagram'" src="/icons/insta1.svg">
          <img v-if="item.customer.utm.source == 'yandex'" src="/icons/yandex1.svg">
          <img v-if="item.customer.utm.source == 'google'" src="/icons/google1.svg">
          <img v-if="item.customer.utm.source == 'vk'" src="/icons/vk1.svg">
        </template>
      </div>
    </template>
    <template v-slot:[`item.info`]="{ item }">
      <template v-if="item.leadType == 'site' || item.leadType == 'cabinet'">
        {{ item.leadHeader }}
        <template v-if="item.leadMessage">
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon small>mdi-information-outline</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-card-text>
                {{ item.leadMessage }}
              </v-card-text>
            </v-card>
          </v-menu>
        </template>
      </template>
      <template v-if="item.leadType == 'action'">
        Добавлен вручную.
      </template>
      <template v-if="item.leadType == 'call-in'">
        <audio v-if="item.additionalInfo.recordUrl" controls :src="item.additionalInfo.recordUrl"></audio>
        <span v-else>{{ item.callTypeText }}</span>
      </template>
    </template>
  </v-data-table>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
//import CustomerCard from './CustomerCard';

export default {
  name: 'leads-table',

  /*components: {
    'customer-card': CustomerCard
  },*/

  props: {
    leads: Array,
    singleCustomer: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    let headers = [
      {
        text: 'Дата и время',
        value: 'createdAt'
      },
      {
        text: 'Тип',
        value: 'leadTypeText'
      },
      {
        text: 'Клиент',
        value: 'customer'
      },
      {
        text: 'Город',
        value: 'customer.site.city.name'
      },
      {
        text: 'Доп. информация',
        value: 'info'
      }
    ];
    return {
      leadsHeaders: this.singleCustomer ? [headers[0], headers[1], headers[4]] : headers,

    };
  },

  computed: {
    ...mapState('customers', ['customersQueryKey'])
  }
}
</script>

<style scoped>
.id-block {
  display: flex; 
  align-items: center;
}
.id-block img {
  height: 13px;
  margin-left: 2px;
}
</style>